import React, { useState } from "react";
import { Grid, Box, Typography, TextareaAutosize } from "@mui/material";
import { tokens } from "../../Common/designTokens";

const commentTextAreaStyle = {
  width: "100%",
  minHeight: "32px",
  padding: "8px",
  boxSizing: "border-box",
  border: `1px solid ${tokens.colors.bodyBorderColor50}`,
  borderRadius: "8px",
  backgroundColor: tokens.colors.white,
  color: tokens.colors.fontColour,
  resize: "vertical",
  fontFamily: "inherit",
  fontSize: "inherit",
  wordWrap: "break-word",
  whiteSpace: "pre-wrap",
  overflowX: "hidden",
  lineHeight: "32px",
  "&:disabled": {
    opacity: 0.95,
    backgroundColor: tokens.colors.defaultGridRowColor,
    cursor: "not-allowed",
    color: tokens.colors.disabledFontColour,
  },
  "&:focus": {
    outline: "none",
    border: `1px solid ${tokens.palette.primaryA25 || tokens.palette.primaryA30}`,
  },
};

const OrderComments = ({
  comments,
  handleChange,
  isFieldEditable,
  // Grid width, so a caller can drop this into a partly-filled row instead of giving it one
  // of its own. Defaults to the full 12 the Bond Order tab has always used, so that tab and
  // every other existing caller render exactly as before.
  xs = 12,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Grid item xs={xs}>
      <Box sx={{ position: "relative", width: "100%" }}>
        <TextareaAutosize
          name="comments"
          value={comments || ""}
          onChange={(e) => {
            if (e.target.value.length <= 200) {
              handleChange(e);
            }
          }}
          placeholder="Add Comments"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={!isFieldEditable("comments")}
          minRows={1}
          maxRows={5}
          style={{
            ...commentTextAreaStyle,
            outline: 'none',
            border: `1px solid ${isFocused ? tokens.palette.primary : tokens.colors.bodyBorderColor50}`,
            boxShadow: isFocused ? `0 0 0 3px ${tokens.palette.primaryA10 || tokens.palette.primaryA30}` : 'none',
            WebkitBoxShadow: isFocused ? `0 0 0 3px ${tokens.palette.primaryA10 || tokens.palette.primaryA30}` : 'none',
            height: "46px",
            minHeight: "46px",
            ...(!isFieldEditable("comments") && {
              opacity: 0.95,
              backgroundColor: tokens.colors.defaultGridRowColor,
              cursor: "not-allowed",
              color: tokens.colors.disabledFontColour,
              resize: "none",
              boxShadow: 'none',
              WebkitBoxShadow: 'none',
            }),
          }}
        />
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: 4,
            right: 8,
            color:
              (comments?.length || 0) > 200
                ? "error.main"
                : tokens.colors.fontColour80,
            fontSize: "0.75rem",
            pointerEvents: "none",
          }}
        >
          {comments?.length || 0}/200
        </Typography>
      </Box>
    </Grid>
  );
};

export default OrderComments;
